import { createBreakpoint } from 'react-use';
import theme from 'tailwindcss/defaultTheme';

export const breakpoints = {
    xs: 0,
    sm: Number.parseInt(theme.screens.sm) * 16,
    md: Number.parseInt(theme.screens.md) * 16,
    lg: Number.parseInt(theme.screens.lg) * 16,
    xl: Number.parseInt(theme.screens.xl) * 16,
    '2xl': Number.parseInt(theme.screens['2xl']) * 16,
};

export const useBreakpoints = createBreakpoint(breakpoints) as () => keyof typeof breakpoints;
